(() => {
  "use strict";
  // v21 – Popup exakt ÜBER dem Button, um einige px versetzt. Margin via data-atc-margin steuerbar (Default 12).
  const FORM_SEL = 'form[action*="/cart/add"]';
  const BTN_SEL  = 'button[name="add"], button[type="submit"], .product-form__submit, .shopify-payment-button, .dynamic-checkout';

  const scopeOf = (el) => el.closest('product-form') || el.closest(FORM_SEL) || el.closest('[id^="shopify-section"]') || document;
  const findAnchor = (btn) =>
    btn.closest('.product-form__buttons') ||
    btn.closest(FORM_SEL) ||
    btn.parentElement;

  const getMargin = () => {
    const v = document.documentElement.dataset.atcMargin;
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 12; // px Abstand zwischen Buttonoberkante und Kartenunterkante
  };

  function buildHint(state, anchor){
    if (state.hint && state.anchor === anchor) return state.hint.el;

    const el = state.hint?.el || document.createElement('div');
    el.className = 'atc-hint';
    el.setAttribute('role','alert');
    el.setAttribute('aria-live','polite');

    let card = el.querySelector('.atc-hint__card');
    let letters;
    if (!card){
      card = document.createElement('div'); card.className = 'atc-hint__card';
      const title = document.createElement('div'); title.className = 'atc-hint__title'; title.textContent = 'Noch ein Schritt';
      letters = document.createElement('div'); letters.className = 'atc-hint__letters';
      letters.setAttribute('aria-label','Bitte zuerst Farbe & Größe wählen');

      const text = 'Bitte zuerst Farbe & Größe wählen';
      let fromLeft = true, i = 0;
      for (const ch of text){
        if (ch === ' '){
          const sp = document.createElement('span'); sp.className='space'; sp.textContent=' ';
          letters.appendChild(sp); continue;
        }
        const span = document.createElement('span'); span.className='char'; span.textContent = ch;
        span.style.setProperty('--from', fromLeft ? '-14px' : '14px');
        span.style.setProperty('--rot',  fromLeft ? '-6deg'  : '6deg');
        span.style.setProperty('--delay', (100 + i*24) + 'ms');
        letters.appendChild(span); fromLeft = !fromLeft; i++;
      }

      card.appendChild(title); card.appendChild(letters); el.appendChild(card);
    } else {
      letters = el.querySelector('.atc-hint__letters');
    }

    anchor.classList.add('atc-anchor-rel');
    if (!el.parentNode || el.parentNode !== anchor) anchor.appendChild(el);

    state.hint = { el, card, letters };
    state.anchor = anchor;
    return el;
  }

  // Karte exakt über der Button-Oberkante platzieren – mit konfigurierbarer Margin
  function placeHint(btn, state){
    const a = state.anchor.getBoundingClientRect();
    const b = btn.getBoundingClientRect();
    const cr = state.hint.card.getBoundingClientRect();
    const margin = getMargin(); // px

    const x = b.left - a.left + b.width/2;
    const y = b.top  - a.top  - cr.height - margin; // Unterkante der Karte ist `margin` über Button-Oberkante

    state.hint.el.style.left = `${x}px`;
    state.hint.el.style.top  = `${Math.max(0, y)}px`;
  }

  function animateIn(state){
    state.hint.card.style.willChange = 'transform, opacity';
    state.hint.el.classList.add('atc-hint--show');
    requestAnimationFrame(() => {
      state.hint.letters.querySelectorAll('.char').forEach(ch => ch.classList.add('char--in'));
    });
    const clear = () => { state.hint.card.style.willChange = ''; state.hint.card.removeEventListener('animationend', clear); };
    state.hint.card.addEventListener('animationend', clear);
  }

  function hideHint(state){
    if (!state.hint) return;
    state.hint.el.classList.remove('atc-hint--show');
    state.hint.letters.querySelectorAll('.char').forEach(ch => ch.classList.remove('char--in'));
    window.removeEventListener('scroll', state.onPos, true);
    window.removeEventListener('resize', state.onPos, true);
    clearTimeout(state.hideTimer);
    state.onPos = null;
  }

  function showHint(btn, state){
    const scope  = scopeOf(btn);
    if (!scope.classList.contains('atc-locked')) return;

    const anchor = findAnchor(btn);
    buildHint(state, anchor);
    placeHint(btn, state);
    animateIn(state);

    let ticking = false;
    state.onPos = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { placeHint(btn, state); ticking = false; });
    };
    window.addEventListener('scroll', state.onPos, true);
    window.addEventListener('resize', state.onPos, true);

    clearTimeout(state.hideTimer);
    state.hideTimer = setTimeout(() => hideHint(state), 2200);
  }

  function bind(root=document){
    if (root.__atcSpinBound) return;
    root.__atcSpinBound = true;

    const state = { hint:null, anchor:null, onPos:null, hideTimer:null };

    root.addEventListener('click', (e) => {
      const btn = e.target.closest(BTN_SEL);
      if (!btn) return;
      const scope = scopeOf(btn);
      if (!scope.classList.contains('atc-locked')) return;

      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      showHint(btn, state);
    }, true);

    document.addEventListener('shopify:section:load', (ev) => {
      root.__atcSpinBound = false; bind(ev.target);
    });
  }

  document.addEventListener('DOMContentLoaded', () => bind(document));
})();
